import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcelWithoutDisplayNone,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";

function MarketingScore() {
  const globalState = useGlobalState();
  const [showModal, setShowModal] = useState(false);
  const [isAnimation, setIsAnimation] = useState(false);
  const [IsDriver, setIsDriver] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [MNVMoverTipAmountID, setMNVMoverTipAmountID] = useState(0);
  const [tippingObject, setTippingObject] = useState<any>({
    EndDate: getEndOfMonth(),
    JobID: "",
    MNVMoverID: 0,
    StartDate: getStartOfMonth(),
    EarningsView: true,
    Total: 0,
  });

  const [movers, setMovers] = useState<any>([]);
  const [moversData, setMoversData] = useState<any>([]);
  const [gridData, setGridData] = useState<any>([]);
  const [EarningsDetails, setEarningsDetails] = useState<any>([]);

  useEffect(() => {
    ClearFilters(false);
    setIsDriver(globalState.IsDriverLoggedIn);
    getDriverJobsWithTipping();
  }, [clearFilters]);

  function ClearFilters(clear: boolean) {
    var l_oToday = new Date();

    setTippingObject((prevState: any) => ({
      ...prevState,
      StartDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth(),
        1,
        10,
        0,
        0,
        0
      ).toLocaleDateString("en-CA"),
      EndDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth() + 1,
        0,
        10,
        0,
        0,
        0
      ).toLocaleDateString("en-CA"),
      JobID: "",
      MNVMoverID: 0,
    }));
    if (clear == true) setClearFilters(!clearFilters);
  }

  function getDriverJobsWithTipping() {
    setIsAnimation(true);
    let object = tippingObject;
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVQuoteAdmin/MNVAdvertisementDataGetDataForDashboard",
        object
      )
      .then((response) => {
        if (response.status === 200) {
          let l_response = response.data;

          setGridData(l_response[0]);
          if (movers == null || movers.length == 0) setMovers(l_response[1]);
          // setMoversData(l_response[3]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-btw mb-10">
              <div className="flex-da gap-10">
                <div className="field-input date-field">
                  <input
                    type="date"
                    title="Service Start Date"
                    placeholder="Lag"
                    value={tippingObject.StartDate}
                    onChange={(e) =>
                      setTippingObject((prevState: any) => ({
                        ...prevState,
                        StartDate: e.target.value,
                      }))
                    }
                    className="input-field"
                  />
                </div>
                <div className="field-input date-field">
                  <input
                    type="date"
                    title="Service End Date"
                    placeholder="Lag"
                    value={tippingObject.EndDate}
                    onChange={(e) =>
                      setTippingObject((prevState: any) => ({
                        ...prevState,
                        EndDate: e.target.value,
                      }))
                    }
                    className="input-field"
                  />
                </div>
                <div className="field-input">
                  <select
                    className="input-field"
                    value={tippingObject.MNVMoverID}
                    onChange={(e) =>
                      setTippingObject((prevState: any) => ({
                        ...prevState,
                        MNVMoverID: e.target.value,
                      }))
                    }
                  >
                    <option value={0}>Select Driver</option>
                    {movers &&
                      movers.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <option value={item.PID}>{item.Name}</option>
                        </React.Fragment>
                      ))}
                  </select>
                </div>
                <div className="flex-daj btn-start flex-gap10">
                  <a
                    onClick={() => ClearFilters(true)}
                    className="btn-primary flex-daj"
                  >
                    Clear Filters
                  </a>
                  <a
                    onClick={() => getDriverJobsWithTipping()}
                    className="btn-primary flex-daj"
                  >
                    Filter
                  </a>
                </div>
                <span></span>
              </div>

              <div className="flex-daj btn-start gap-10">
                <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcelWithoutDisplayNone(
                      "tblmarketingscore",
                      "Marketing Score"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>
            <div className="flow-auto-sm">
              <table className="reuse-table">
                <thead>
                  <tr>
                    <th>Job ID</th>
                    <th>Date</th>
                    <th>Driver</th>
                    <th>Review</th>
                    <th>Business Card</th>
                    <th>Magnetic Card</th>
                    <th>Social Media leaflet</th>
                  </tr>
                </thead>
                <tbody>
                  {gridData &&
                    gridData.map((Item: any, index: any) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td>
                            {" "}
                            <a
                              href={"/quote_detail/" + Item.MNVJobID}
                              target="_blank"
                            >
                              #{Item.JobID}
                            </a>
                          </td>
                          <td>{formateDate(Item.RequestedDate)}</td>
                          <td>{Item.MoverName}</td>

                          <td className="text-center">
                            {Item.IsReviewEmailSent == 1 ? (
                              <img
                                src="images/tick-g.svg"
                                alt="tick"
                                width={18}
                                height={18}
                              />
                            ) : (
                              <img
                                src="images/r-cross.svg"
                                alt="cross"
                                width={18}
                                height={18}
                              />
                            )}
                          </td>

                          <td className="text-center">
                            {Item.BusinessCard == 1 ? (
                              <img
                                src="images/tick-g.svg"
                                alt="tick"
                                width={18}
                                height={18}
                              />
                            ) : (
                              <img
                                src="images/r-cross.svg"
                                alt="cross"
                                width={18}
                                height={18}
                              />
                            )}
                          </td>

                          <td className="text-center">
                            {Item.MagneticCard == 1 ? (
                              <img
                                src="images/tick-g.svg"
                                alt="tick"
                                width={18}
                                height={18}
                              />
                            ) : (
                              <img
                                src="images/r-cross.svg"
                                alt="cross"
                                width={18}
                                height={18}
                              />
                            )}
                          </td>

                          <td className="text-center">
                            {Item.SocialMediaLeaflet == 1 ? (
                              <img
                                src="images/tick-g.svg"
                                alt="tick"
                                width={18}
                                height={18}
                              />
                            ) : (
                              <img
                                src="images/r-cross.svg"
                                alt="cross"
                                width={18}
                                height={18}
                              />
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>



              <table className="reuse-table no-display" id="tblmarketingscore">
                <thead>
                  <tr>
                    <th>Job ID</th>
                    <th>Date</th>
                    <th>Driver</th>
                    <th>Review</th>
                    <th>Business Card</th>
                    <th>Magnetic Card</th>
                    <th>Social Media leaflet</th>
                  </tr>
                </thead>
                <tbody>
                  {gridData &&
                    gridData.map((Item: any, index: any) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td>
                            {" "}
                            <a
                              href={"/quote_detail/" + Item.MNVJobID}
                              target="_blank"
                            >
                              #{Item.JobID}
                            </a>
                          </td>
                          <td>{formateDate(Item.RequestedDate)}</td>
                          <td>{Item.MoverName}</td>

                          <td className="text-center">
                            {Item.IsReviewEmailSent == 1 ? (
                              "Yes"
                            ) : (
                              "No"
                            )}
                          </td>

                          <td className="text-center">
                            {Item.BusinessCard == 1 ? (
                              "Yes"
                            ) : (
                              "No"
                            )}
                          </td>

                          <td className="text-center">
                            {Item.MagneticCard == 1 ? (
                              "Yes"
                            ) : (
                              "No"
                            )}
                          </td>

                          <td className="text-center">
                            {Item.SocialMediaLeaflet == 1 ? (
                              "Yes"
                            ) : (
                              "No"
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>

            </div>
          </>
        </>
      )}
    </div>
  );
}

export default MarketingScore;
